// 统一请求路径前缀在libs/axios.js中修改
import {
  doPostRequest,
  postDataRequest,
  getusrdataRequest,
  saveusrDataRequest,
  getRequest2,
  getphoneRequest,
  deletePRequest,
  deleteMideaRequest,
  getRequest4,
  getRequest3,
  showmideaRequest,
  saveDataRequest_audit,
  showDataRequest,
  saveDataRequest,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  importRequest,
  uploadFileRequest,
} from '@/utils/axios';

// 获取属性结构的参数   /zituSpace/directory/getByParentId/0
export const getNodeTree = params => {
  return postRequest(`/directory/getByParentId/${params.parentId}`, params);
};
// 保存发布服务的接口
// /zituSpace/servicepublish/publishsdfile    /zituSpace/layer/geoserverPublishPostGISData
export const saveData = params => {
  // return postRequest(`/servicepublish/publishsdfile`, params)
  // return postRequest(`/uploader/publishShape`, params)
  return postRequest(`/layer/geoserverPublishPostGISData`, params);
};
// 获取arcgis服务的目录树 localhost:8888/zituSpace/agsservicemanager/findArcgisDireTree  post   http://localhost:8899/zituSpace/geoserver/getGeoserverList
export const getArcGisNode = params => {
  // return postRequest(`/agsservicemanager/findArcgisDireTree`, params)
  // return postRequest(`/geoserver/getGeoserverList`, params)
  return postRequest(`/layer/getGeoserverWorkspaceList`, params);
};
//图层树管理获取geoserver  服务   /zituSpace/layer/getGeoserverList
export const getServiceNode = params => {
  return postRequest(`/layer/getGeoserverList`, params);
};
//  获取arcgis服务列表  localhost:8888/zituSpace/agsservicemanager/findArcgisServerList?pageSize=10&pageNumber=1&currentFolder=hsp
export const getArcGisList = params => {
  return postRequest(`/agsservicemanager/findArcgisServerList`, params);
};
//  获取geoServer服务列表  /zituSpace/agsservicemanager/findGeoserverServerList
export const getgeoServerList = params => {
  return postRequest(`/agsservicemanager/findGeoserverServerList`, params);
};
// 更新分享状态的接口  /zituSpace/agsservicemanager/updateShareState   serviceName   serviceType  directoryId
export const getChangeState = params => {
  return postRequest(`/agsservicemanager/updateShareState`, params);
};
// 获取图层目录的接口数据  localhost:8888/zituSpace/agsservicemanager/getServerLayers?serviceName=ceshi123&serviceType=mapServer&folder=/
export const getArcgisService = params => {
  return postRequest(`/agsservicemanager/getServerLayers`, params);
};
// /agsservicemanager/preview  请求展示的数据
export const getpreviewMap = params => {
  return postRequest(`/agsservicemanager/preview`, params);
};



// WEBPACK FOOTER //
// ./src/api/service-publish.js